module.exports = function (DefaultPointMarker, DefaultSegmentMarker, Konva) {
    'use strict';
    function createSegmentMarker(options) {
        if (options.view === 'zoomview') {
            return new DefaultSegmentMarker(options);
        }
        return null;
    }
    function createSegmentLabel(options) {
        return new Konva.Text({
            x: 12,
            y: 12,
            text: options.segment.labelText,
            textAlign: 'center',
            fontFamily: options.fontFamily || 'sans-serif',
            fontSize: options.fontSize || 12,
            fontStyle: options.fontStyle || 'normal',
            fill: '#000'
        });
    }
    function createPointMarker(options) {
        return new DefaultPointMarker(options);
    }
    return {
        createSegmentMarker: createSegmentMarker,
        createSegmentLabel: createSegmentLabel,
        createPointMarker: createPointMarker
    };
}(require('./default-point-marker'), require('./default-segment-marker'), require('konva'));